import { render } from "./WeekCyclesOptionTotals.vue?vue&type=template&id=12bea9dc"
import script from "./WeekCyclesOptionTotals.vue?vue&type=script&lang=js"
export * from "./WeekCyclesOptionTotals.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__